import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-surface-950 border-t border-line text-white">
      {/* Main Footer Section */}
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 py-14 px-6 md:px-8 gap-12">
        {/* Logo Section */}
        <div className="flex items-center justify-center md:justify-start">
          <div
            className="bg-logo-192 bg-no-repeat bg-contain hover:opacity-90 transition-opacity cursor-pointer"
            style={{ width: "160px", height: "160px" }}
            onClick={() => navigate("/")}
          ></div>
        </div>

        {/* Content Section */}
        <div className="flex flex-col space-y-8">
          {/* Title */}
          <div className="text-2xl font-semibold tracking-tight">
            <span className="text-accent">Dynasty</span>{" "}
            <span className="text-gray-200">Sounds and Creations</span>
          </div>

          {/* Navigation Links */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-3 text-sm">
            {[
              ["Home", "/"],
              ["News", "/news"],
              ["Sports", "/sports"],
              ["Subscription Plans", "/subscription-plans"],
            ].map(([label, path]) => (
              <button
                key={path}
                onClick={() => navigate(path)}
                className="text-left text-gray-400 hover:text-white transition-colors duration-150"
              >
                {label}
              </button>
            ))}
          </div>

          {/* Contact Info */}
          <div className="space-y-3 text-sm text-gray-400">
            <div className="flex items-center space-x-2">
              <span className="text-gray-500">Email:</span>
              <a
                href="mailto:dynastyempire28@gmail.com"
                className="hover:text-accent transition-colors duration-150"
              >
                dynastyempire28@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-line">
        <div className="container mx-auto py-6 px-6 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-sm text-gray-500">
            © {new Date().getFullYear()} DESAC TV. All Rights Reserved
          </div>
          <div className="flex space-x-6 text-sm text-gray-500">
            <button
              onClick={() => navigate("/privacy")}
              className="hover:text-white transition-colors duration-150"
            >
              Privacy Policy
            </button>
            <button
              onClick={() => navigate("/terms")}
              className="hover:text-white transition-colors duration-150"
            >
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
